import Address, { IAddressDto } from "./Address"
import CustomerContact, { ICustomerContactDto } from "./CustomerContact"

export interface ICustomerDto {
    name: string
    number?: string | null
    address?: IAddressDto | null
    customerContact?: ICustomerContactDto | null
}

export default class Customer {
    name: string
    number?: string
    address?: Address
    customerContact?: CustomerContact

    constructor(dto: ICustomerDto) {
        this.name = dto.name
        this.number = dto.number ?? undefined
        this.address = dto.address ? new Address(dto.address) : undefined
        this.customerContact = dto.customerContact ? new CustomerContact(dto.customerContact) : undefined
    }

    toDto(): ICustomerDto | undefined {
        return this.isEmpty() ? undefined : {
            name: this.name,
            number: this.number,
            address: this.address?.toDto(),
            customerContact: this.customerContact?.toDto(),
        }
    }

    isEmpty(): boolean {
        return Boolean(
            !this.name
            && !this.number
            && (!this.address || this.address.isEmpty())
            && (!this.customerContact || (!this.customerContact.name && !this.customerContact.telephone))
        )
    }
}
